import React from 'react'
import HeaderContent from './header-content'
// import HeaderSearch from './header-search'
import ProfileInfo from './profile-info'
// import Notifications from './notifications'
// import Messages from "./messages"
import ThemeSwitcher from './theme-switcher'
// import HorizontalMenu from "./horizontal-menu"
import HeaderLogo from "./header-logo"
// import SidebarHoverToggle from '../sidebar/sidebar-hover-toggle'
import { useConfig } from 'hooks/use-config'
import { Menu } from "lucide-react"
import { Button } from "components/ui/button";


const StorboltHeader = () => {
    const [config, setConfig] = useConfig();

    return (
        <>
            <HeaderContent>
                <div className='flex gap-2 items-center'>
                    <Button size="icon" variant="ghost" color="secondary"
                            className="lg:hidden -ms-2 h-10 w-10 text-default-900"
                            onClick={() => setConfig({
                                ...config,
                                menuHidden: !config.menuHidden,
                                collapsed: false
                            })}>
                        <Menu className="h-5 w-5"/>
                        <span className="sr-only">Toggle menu</span>
                    </Button>
                    <HeaderLogo/>
                    {/*<HeaderSearch />*/}
                </div>
                <div className="nav-tools flex items-center gap-2 md:gap-3">
                    <ThemeSwitcher/>
                    {/*<Messages />*/}
                    {/*<Notifications />*/}
                    <ProfileInfo/>
                </div>
            </HeaderContent>
            {/* <HorizontalMenu /> */}
        </>
    )
}

export default StorboltHeader